import * as React from 'react';
import { Box } from '@drone-js/core';

var COLUMN_SIZE = 3;
var MonthYearContainer = function MonthYearContainer(props) {
  return /*#__PURE__*/React.createElement(Box, {
    "data-testid": props.testId,
    position: "absolute",
    top: "0px",
    width: "100%",
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, props.header), /*#__PURE__*/React.createElement(Box, {
    as: "table",
    ref: props.containerGridRef,
    width: "100%",
    maxWidth: "none",
    p: "16"
  }, /*#__PURE__*/React.createElement(Box, {
    as: "tbody",
    display: "flex",
    flexDirection: "column",
    gap: "32"
  }, Array.from({
    length: 4
  }).map(function (_, i) {
    return /*#__PURE__*/React.createElement(Box, {
      as: "tr"
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: i,
      display: "flex",
      gap: "12"
    }, Array.from({
      length: 3
    }).map(function (__, j) {
      return props.buttonCell(i * COLUMN_SIZE + j);
    }));
  }), props.children)));
};

export { MonthYearContainer };
//# sourceMappingURL=MonthYearContainer.js.map
